import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import HamburgerIcon from "core/ReusableIcons/Hamburger.js";

// styles
import colors from "core/colors";

// component
export const Hamburger = () => {
    const { isDarkMode } = useSiteHeader();
    return (
        <HamburgerIcon
            size={{ width: 28, height: 40 }}
            fillColor={isDarkMode ? colors.primary.snow : colors.secondary.orca}
        />
    );
};

export default Hamburger;
